import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import useAuthStore from "../../../mobile/store/authStore";
import { adminLogin } from '../../../mobile/api/AuthApi';
import { me } from '../../../mobile/api/MemberApi';

const LoginPage = () => {
    const navigate = useNavigate();
    const authStore = useAuthStore();

    const [loginForm, setLoginForm] = useState({
        name: '',
        password1: '',
        password2: '',
        code: ''
    });

    const handleLogin = async () => {
        try {
            const tokenResponse = await adminLogin(loginForm.name, loginForm.password1, loginForm.password2, loginForm.code);
            authStore.setToken(tokenResponse.accessToken, tokenResponse.refreshToken);

            const memberResponse = await me(tokenResponse.accessToken);
            authStore.setMember(memberResponse);
            alert("로그인 성공");            
            navigate("/admin/dashboard");
        } catch (error) {
            alert('정보가 올바르지 않습니다.');
        }
    };

    return (
        <div className="h-screen bg-gray-100 flex items-center justify-center">
            <div className="bg-white border border-gray-400 p-4 w-72">
                <h1 className="text-sm font-bold text-gray-800 mb-3 text-center">밥친구 어드민 로그인</h1>
                
                <div className="space-y-2">
                    <div>
                        <input 
                            type="text" 
                            placeholder="아이디" 
                            className="w-full px-2 py-1 border border-gray-300 text-xs focus:outline-none focus:border-gray-400" 
                            value={loginForm.name} 
                            onChange={(e) => setLoginForm({ ...loginForm, name: e.target.value })} 
                        />
                    </div>
                    
                    <div>
                        <input 
                            type="password" 
                            placeholder="1차 비밀번호" 
                            className="w-full px-2 py-1 border border-gray-300 text-xs focus:outline-none focus:border-gray-400" 
                            value={loginForm.password1} 
                            onChange={(e) => setLoginForm({ ...loginForm, password1: e.target.value })} 
                        />
                    </div>
                    
                    <div>
                        <input 
                            type="password" 
                            placeholder="2차 비밀번호" 
                            className="w-full px-2 py-1 border border-gray-300 text-xs focus:outline-none focus:border-gray-400" 
                            value={loginForm.password2} 
                            onChange={(e) => setLoginForm({ ...loginForm, password2: e.target.value })} 
                        />
                    </div>
                    
                    <div>
                        <input 
                            type="password" 
                            placeholder="보안코드" 
                            className="w-full px-2 py-1 border border-gray-300 text-xs focus:outline-none focus:border-gray-400" 
                            value={loginForm.code} 
                            onChange={(e) => setLoginForm({ ...loginForm, code: e.target.value })} 
                        />
                    </div>
                    
                    <button
                        className="w-full px-2 py-1 bg-gray-200 border border-gray-400 hover:bg-gray-300 text-xs mt-3"
                        onClick={handleLogin}
                    >
                        로그인
                    </button>
                </div>
            </div>
        </div>
    );
};

export default LoginPage;
